import { MortgageInterface } from '@app/interfaces/mortgage.interface';

export class FillingScore500 {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static check(mortgage: MortgageInterface): boolean {
        return true;
    }
}
